import { render, staticRenderFns } from "./WaitingBlock.vue?vue&type=template&id=0afb07a6&scoped=true&"
var script = {}
import style0 from "./WaitingBlock.vue?vue&type=style&index=0&id=0afb07a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afb07a6",
  null
  
)

export default component.exports